// extracted by mini-css-extract-plugin
module.exports = {"content":"_93444fe79c--content--VcYgJ","icon":"_93444fe79c--icon--p_jbg","heading":"_93444fe79c--heading--vl9QP","footer":"_93444fe79c--footer--veeUl"};